module.exports = __webpack_public_path__ + "ptc_momoro_V2.7f574569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_V2.jpg
// module id = jvDB
// module chunks = 0